export const realEstateNavItems = {
  services: 'Servicios',
  landPlot: 'Terreno',
};

export const realEstateSecondDescription =
  'Nuestro objetivo es ayudarle a encontrar la casa de sus sueños, tanto si desea comprar como alquilar. Ofrecemos una amplia gama de propiedades en diferentes ubicaciones y estilos, por lo que seguro que encontrará algo que se adapte a sus necesidades y presupuesto. Eche un vistazo a nuestras propiedades destacadas a continuación o utilice la barra de búsqueda para encontrar un tipo específico de propiedad o ubicación. Si necesita ayuda o tiene alguna pregunta, no dude en ponerse en contacto con nosotros.';
